<template>
  <div class="filters">
    <div class="filters__container">
      <UniversalSelect
        v-model="filters.applications"
        style="width: 180px;"
        :options="appsOptions"
        placeholder="App"
        title="App"
        :showSearch="true"
        :disabled="loading || disabled"
        @change="changeAppFilter"
      />
      <!-- <UniversalSelect
        v-model="filters.languages"
        style="width: 150px;"
        :options="languageOptions"
        placeholder="Language"
        title="Language"
        :showSearch="true"
        :disabled="loading || disabled"
        @change="changeLanguageFilter"
      /> -->
      <UniversalSelect
        v-model="filters.type"
        style="width: 150px;"
        :options="typeOptions"
        placeholder="Type"
        title="Type"
        :showSearch="true"
        :disabled="loading || disabled"
        @change="sendFiltersEvent"
      />
      <UniversalSelect
        v-model="filters.segment"
        style="width: 180px;"
        :options="segmentOptions"
        placeholder="Segment"
        title="Segment"
        :showSearch="true"
        :disabled="loading || disabled"
        @change="changeSegmentFilter"
      />
      <div class="d-flex flex-column">
        <span class="font-weight-bold">Start date</span>
        <a-date-picker
          v-model="filters.startDate"
          format="YYYY-MM-DD HH:mm"
          :show-time="{
            defaultValue: $moment('00:00:00', 'HH:mm'),
            format: 'HH:mm'
          }"
          type="date"
          size="large"
          placeholder="Start date"
          :disabled="loading || disabled"
          @change="changeStartDate"
        />
      </div>
      <div class="d-flex flex-column">
        <span class="font-weight-bold">End date</span>
        <a-date-picker
          v-model="filters.endDate"
          format="YYYY-MM-DD HH:mm"
          :show-time="{
            defaultValue: $moment('00:00:00', 'HH:mm'),
            format: 'HH:mm'
          }"
          type="date"
          size="large"
          placeholder="End date"
          :disabled="loading || disabled"
          @change="changeEndDate"
        />
      </div>
      <UniversalSelect
        v-model="filters.status"
        style="width: 130px;"
        :options="statusOptions"
        placeholder="Status"
        title="Status"
        :disabled="loading || disabled"
        @change="changeStatusFilter"
      />
      <div class="d-flex align-items-end" style="height: 62px;">
        <SearchField
          :value="filters.name"
          :loading="loading"
          :disabled="loading || disabled"
          @search="changeSearchValue"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UniversalSelect from '@/components/custom/filters/universalSelect.vue'
import SearchField from '@/components/custom/form/SearchField.vue'
import { setFilters } from '@/composables/useSetQueryParams.js'

export default {
  props: {
    appsOptions: {
      type: Array,
      default: () => [],
    },
    languageOptions: {
      type: Array,
      default: () => [],
    },
    typeOptions: {
      type: Array,
      default: () => [],
    },
    segmentOptions: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    UniversalSelect,
    SearchField,
  },
  data: () => ({
    statusOptions: [
      { name: 'Active', value: 'active' },
      { name: 'Inactive', value: 'inactive' },
    ],
    filters: {
      applications: undefined,
      // languages: undefined,
      type: undefined,
      segment: undefined,
      startDate: undefined,
      endDate: undefined,
      status: undefined,
      name: undefined,
    },
  }),
  methods: {
    setQueryFilters(newFilters) {
      setFilters(newFilters, this)
    },
    changeAppFilter() {
      this.sendFiltersEvent()
    },
    changeLanguageFilter() {
      this.sendFiltersEvent()
    },
    changeSegmentFilter() {
      this.sendFiltersEvent()
    },
    changeStartDate() {
      this.sendFiltersEvent()
    },
    changeEndDate() {
      this.sendFiltersEvent()
    },
    changeStatusFilter() {
      this.sendFiltersEvent()
    },
    changeSearchValue(value) {
      this.filters.name = value
      this.sendFiltersEvent()
    },
    getFilters() {
      return {
        applications: this.filters.applications,
        // languages: this.filters.languages,
        type: this.filters.type,
        segment: this.filters.segment,
        starts_at: this.filters.startDate
          ? this.$moment.isMoment(this.filters.startDate)
            ? this.filters.startDate.format('YYYY-MM-DD HH:mm')
            : this.filters.startDate
          : undefined,
        ends_at: this.filters.endDate
          ? this.$moment.isMoment(this.filters.endDate)
            ? this.filters.endDate.format('YYYY-MM-DD HH:mm')
            : this.filters.endDate
          : undefined,
        status: this.filters.status,
        name: this.filters.name,
      }
    },
    sendFiltersEvent() {
      const filters = this.getFilters()
      this.$emit('change', filters)
    },
    resetFilters() {
      Object.keys(this.filters).forEach(key => {
        this.filters[key] = undefined
      })
      this.$router.push(`${this.$route.path}`)
    },
  },
}
</script>

<style lang="scss">
.filters {
  display: flex;
  flex-direction: column;
  gap: 10px;
  &__container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
  }
}
</style>
